(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.bank-account-display', [
    'pp.widgets-templates',
    'pp.filters.text'
]);

ngModule.component('ppBankAccountDisplay', {
    templateUrl: 'widgets/_angular/bank-account-display/bank-account-display.tpl.html',
    bindings: {
        account: '<'
    },
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);